import styled from 'styled-components';
import { Colors } from '../../../types';

export const MenuContainer = styled.nav`
  position: relative;
  padding: 0;
  margin: 0;
`;

export const MenuList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  border-right: 1px solid var(--base-color-${Colors.LightGrey});
  li {
    margin-left: -5px;
  }
`;

export const MobileButton = styled.button`
  line-height: var(--line-height-navigation);
  font-size: var(--font-size-navigation);
  font-family: var(--font-family-navigation);
  font-weight: var(--font-weight-navigation);
  letter-spacing: var(--letter-spacing-navigation);
  color: var(--base-color-${Colors.Black});
  text-transform: uppercase;
  margin: 0;
  padding: 16px 46px 14px 20px;
  background: var(--base-color-${Colors.White});
  border: 1px solid var(--base-color-${Colors.DarkGrey});
  border-radius: 0;
  display: block;
  width: 100%;
  text-align: left;
  cursor: pointer;
  position: relative;
  span {
    width: 25px;
    height: 25px;
    position: absolute;
    top: 50%;
    margin-top: -12px;
    right: 10px;
  }
`;

export const MenuItem = styled.a<{ isActive: boolean }>`
  line-height: var(--line-height-navigation);
  font-size: var(--font-size-navigation);
  font-family: var(--font-family-navigation);
  font-weight: var(--font-weight-navigation);
  letter-spacing: var(--letter-spacing-navigation);
  color: var(--base-color-${Colors.Black});
  text-transform: uppercase;
  text-decoration: none;
  margin: 0;
  padding: 16px 20px 15px 5px;
  display: block;
  background: ${({ isActive }) => (isActive ? `var(--base-color-${Colors.MidGrey})` : 'none')};
  cursor: pointer;
  &:hover {
    background: var(--base-color-${Colors.MidGrey});
  }
`;

export const MobileMenuList = styled.ul<{ isOpen: boolean }>`
  padding: 0;
  margin: 0;
  list-style: none;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  background: var(--base-color-${Colors.White});
  border: 1px solid var(--base-color-${Colors.DarkGrey});
  border-top: 0;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  ${MenuItem} {
    padding: 16px 20px 15px 20px;
  }
`;
